import React, { useState } from "react";
import CashbookVoucherTable from "../components/CashbookVoucherTable";
import JamaVoucherPreviewModal from "../components/JamaVoucherPreviewModal";
import { voucherRowToSlipData } from "../components/JamaVoucherPDF";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import { getSessionBranchId } from "../utils/sessionBranch";

function PaymentTransaction() {
  const { buttonClass, cardClass, buttonTableStyle } = useButtonTableStyle();
  const branchId = getSessionBranchId();
  const [showSlip, setShowSlip] = useState(false);
  const [voucherData, setVoucherData] = useState(null);

  return (
    <div className="body-wrapper">
      <div className="container-fluid">
        <div
          className={`card w-100 position-relative overflow-hidden ${cardClass} ${buttonTableStyle === "square" ? "rounded-0" : ""
            }`}
        >
          <div className="px-4 py-3 border-bottom">
            <h4 className="card-title mb-0">Transactions</h4>
          </div>
          <div className="card-body p-4">
            {branchId == null ? (
              <div className="text-center text-muted py-4">
                Select a branch to view transactions.
              </div>
            ) : (
              <CashbookVoucherTable
                active
                branchId={branchId}
                defaultChannel=""
                defaultDirection=""
                buttonClass={buttonClass}
                onOpenSlip={(row) => {
                  setVoucherData(voucherRowToSlipData(row));
                  setShowSlip(true);
                }}
              />
            )}
          </div>
        </div>
      </div>
      <JamaVoucherPreviewModal
        show={showSlip}
        onHide={() => {
          setShowSlip(false);
          setVoucherData(null);
        }}
        voucherData={voucherData}
      />
    </div>
  );
}

export default PaymentTransaction;
